import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { DistributionController } from "@app/ui_controllers/distributionController";
import { ActivatedRoute, Router } from "@angular/router";
import { DistributionPageDto } from "@app/ui_models/web-response";
import { MedOptionType } from "@mk/med-ui";
import { DataService } from "@app/services/data.service";
import { SubDistributionDozController } from "@app/ui_controllers/subDistributionDozController";
import { MedNotificationService } from "@mk/med-notification";
import { CryptoController } from "@app/ui_controllers/cryptoController";
import { DecryptedObject, SignatureObject } from "@app/ui_models/crypto.model";
import { StatusTranslatorService } from "@app/services/status.translator.service";
import { env } from "@environments/environment";
import { DocumentsController } from "@app/ui_controllers/documents.controller";
import { attachmentsTabHeader2 } from "@app/components/distribution/doz/column-headers";
import { DistributionDocument } from "@app/ui_models/document.service.models";
import { DocumentFileApiService } from "@app/services/document.file.api.service";
import { DownloadService } from "@app/services/download.service";
import { MedInputStateType } from "@mk/med-ui/lib/components/form/FieldCoreComponent";

@Component({
  selector: "app-distributionDoz",
  templateUrl: "./subDistributionDoz.component.html",
  styleUrls: ["/subDistributionDoz.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SubDistributionDozComponent implements OnInit {

  constructor(private readonly documentsController: DocumentsController,
              private readonly documentFileApiService: DocumentFileApiService,
              private subDistributionController: SubDistributionDozController,
              private distributionController: DistributionController,
              private notificationService: MedNotificationService,
              private route: ActivatedRoute,
              private router: Router,
              private dataService: DataService,
              private cryptoController: CryptoController,
              public readonly downloadService: DownloadService,
              public statusTranslatorService: StatusTranslatorService) {}

  distributionId = -1;
  subDistributionId = -1;
  distribution: DistributionPageDto = {} as DistributionPageDto;
  parentDistribution: DistributionPageDto = {} as DistributionPageDto;
  loadingCounter = 0;
  tabHeader: { label: string; key: string; }[] = tabHeaderSubDistibution;
  attachmentsModal = false;
  reviewModal = false;
  refuseModal = false;
  signModal = false;
  medSignModal = false;
  attachments = { content: [], isLoading: false };
  signedData = "";
  dataToSign = {} as SignatureObject;
  options: MedOptionType<any>[] = [
    {
      label: "Наказ",
      value: 1,
    },
    {
      label: "Протокол",
      value: 2,
    },
  ];
  rows: any = [];
  value = 1;
  signRequestCounter = 0;
  refuseRequestCounter = 0;
  signed = false;
  refused = false;
  READONLY = false;
  distributionApproved = false;
  subDistributionAgreementModal = false;
  showSubDistributionCreationView = false;
  autoDistribution = 50;
  percentageDistribution = 45;
  finalDistribution = 30;
  decryptedObject: DecryptedObject = {} as DecryptedObject;
  signatures: any[] = [];
  commentStatus: MedInputStateType = "";
  comment = "";
  updateRemnantsInProgress = false;
  updateDistribution100FinancedInProgress = false;
  protected readonly alert = alert;
  protected readonly JSON = JSON;

  ngOnInit(): void {
    const param: string|null = this.route.snapshot.paramMap.get("id");
    if (param !== null) {
      this.distributionId = Number.parseInt(param.split("&")[0], 10);

      this.distributionController.getDistributionDoz(this.distributionId).subscribe(data => {
        this.parentDistribution = data;
        this.dataToSign.id = this.parentDistribution.regionRecipientId;
      });
      this.subDistributionId = Number.parseInt(param.split("&")[1], 10);
      this.loadingCounter++;
      this.getSubDistribution();
    }
    this.loadColumnOrder();
    this.getAttachmentsMetaData();
  }

  getSubDistribution(): void {
    this.subDistributionController.getSubDistribution(this.subDistributionId).subscribe(data => {
      if (data["WarnMessage"]) {
        this.notificationService.info(data["WarnMessage"]);
      }
      if (data["subDistribution"]) {
        this.distribution = data["subDistribution"];
      }
      if (data["Data"]) {
        this.rows = data["Data"];
      }
      this.READONLY = this.distribution.status === "COMPLETED";
      this.dataToSign.id = this.distribution.regionRecipientId;
      this.dataToSign.status = "SIGNED";
      this.signatures = this.distribution.signatures;
      this.loadingCounter--;
    });
  }

  saveColumnOrder() {
    localStorage.setItem("subDisctributionDozColumnOrder", JSON.stringify(this.tabHeader));
  }

  saveColumnOrderCustom(key: string, tabHeader: any[]) {
    localStorage.setItem(key, JSON.stringify(tabHeader));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("subDisctributionDozColumnOrder");
    if (savedOrder) {
      this.tabHeader = JSON.parse(savedOrder);
    }
  }

  // setAccess(distributionStatus: string) {
  //   if (this.dataService.isMZU() && ("DRAFT") === distributionStatus) {
  //     this.READONLY = true;
  //   }
  // }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    if (rowElement === "draft") {
      color = "grey";
    } else {
      color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  goToDistributions() {
    this.router.navigate(["/distributions/doz"]);
  }

  signDistribution(): void {
    let errorMessage: string = this.checkIfAnyBeneficiarHasDigitalFraction();
    if (errorMessage) {
      this.notificationService.error(errorMessage);
      return;
    }
    errorMessage = this.checkIfSumInMNNIsCorrect();
    if (errorMessage) {
      this.notificationService.error(errorMessage);
      return;
    }
    errorMessage = this.checkMultiplicity();
    if (errorMessage) {
      this.notificationService.error(errorMessage);
      return;
    }
    this.subDistributionController.completeDistribution(this.subDistributionId).subscribe(data => {
      this.notificationService.success(data["message"]);
      this.subDistributionAgreementModal = false;
      this.distribution.status = "COMPLETED";
      this.signed = true;
      this.reloadComponent("Дочірній розподіл виконано");
    });
  }

  refuseDistribution(): void {

    if (!this.comment) {
      this.notificationService.error("Коментар не вказаний");
      this.commentStatus = "error";
      return;
    }
    this.commentStatus = "success";

    this.subDistributionController.returnToReworking(this.subDistributionId).subscribe(data => {
      this.notificationService.success(data["message"]);
      this.refuseModal = false;
      this.distribution.status = "DRAFT";
    });
  }

  signDone(): void {
    setTimeout(() => {
      this.signed = false;
      this.distributionApproved = true;
      this.READONLY = true;
    }, 400);
    this.signModal = false;
  }

  refuseDone(): void {
    setTimeout(() => {
      this.refused = false;
    }, 1000);
    this.refuseModal = false;
  }

  // createSubDistribution(): void {
  //   this.subDistributionAgreementModal = false;
  //   this.showSubDistributionCreationView = true;
  // }

  goToBasketDoz(): void {
    this.router.navigate(["/distribution/doz/basket"]);
  }

  copyFromAutoToFinal() {
    // @ts-ignore
    this.rows[0].recipients.forEach(recipient => {
      recipient["distributedFinally"] = recipient["distributedAuto"];
    });
  }

  copyFromProportionalToFinal() {
    // @ts-ignore
    this.rows[0].recipients.forEach(recipient => {
      recipient["distributedFinally"] = recipient["distributedProportional"];
    });
  }

  onSign(sign: string) {
    this.cryptoController.verify(sign).subscribe(decryptedObject => {
      this.decryptedObject = decryptedObject;
      this.medSignModal = false;
      // if (this.action.sign) {
      this.signDistribution();
      // } else if (this.action.refuse) {
      //   this.refuseDistribution();
      // }
    });
  }

  reloadComponent(text?: string) {
    const { url } = this.router;
    this.router.navigateByUrl("/refreshing", { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        if (text) {
          this.notificationService.success(text);
        }
      });
    });
  }

  signerFullName(): string {
    let signerFullName = "";
    if (this.distribution && this.distribution.signatures && this.distribution.signatures[0]) {
      const signature = this.distribution.signatures[0].signature as DecryptedObject;
      if (signature) {
        signerFullName = signature.signerInfo.subjFullName;
      }
    }
    return signerFullName;
  }

  signerDate(): string {
    let signerDate = "";
    if (this.distribution && this.distribution.signatures && this.distribution.signatures[0]) {
      const signature = this.distribution.signatures[0].signature as DecryptedObject;
      if (signature) {
        signerDate = signature.signedAt;
      }
    }
    return signerDate;
  }

  getStatus(): string {
    if (!this.distribution) {
      return "";
    }
    return this.statusTranslatorService.getStatusForString(this.distribution.status);
  }

  agreeSubDistribution(): void {
    let errorMessage = this.checkIfAnyBeneficiarHasDigitalFraction();
    if (errorMessage) {
      this.notificationService.error(errorMessage);
      return;
    }
    errorMessage = this.checkIfSumInMNNIsCorrect();
    if (errorMessage) {
      this.notificationService.error(errorMessage);
      return;
    }
    errorMessage = this.checkMultiplicity();
    if (errorMessage) {
      this.notificationService.error(errorMessage);
      return;
    }
    this.subDistributionController.sendToAgreement(this.subDistributionId).subscribe(data => {
      this.notificationService.success(data["message"]);
      this.subDistributionAgreementModal = false;
      this.distribution.status = "AWAITING_DOZ_DISTRIBUTION";
    });
  }

  invokeSignModal(): void {
    if (env.production) {
      this.medSignModal = true;
    } else {
      this.signDistribution();
    }
  }

  inputWithDigitalFraction(count: number): boolean {
    const count1 = count + "";
    return count1.includes(",") || count1.includes(".");
  }

  checkIfAnyBeneficiarHasDigitalFraction(): string {
    let retMessage = "";
    this.rows.forEach((row: any) => {
      row.recipients.forEach((recipient: any) => {
        const finalCount = recipient.distributedFinally + "";
        if (finalCount.includes(",") || finalCount.includes(".")) {
          retMessage = "Комірка у фінальному розподілі має містити ціле число";
        }
      });
    });
    return retMessage;
  }

  checkIfSumInMNNIsCorrect(): string {
    let retMessage = "";

    this.rows.forEach((row: any) => {
      let counter = 0;
      row.recipients.forEach((recipient: any) => {
        if (recipient.distributedFinally) {
          counter += parseInt(recipient.distributedFinally);
        }
      });
      console.log("counter - " + counter + " row.quantity - " + row.quantity);
      if (counter > row.quantity) {
        retMessage = "Кількість товару перевищує доступну для розподілу";
      }
    });

    return retMessage;
  }

  checkMultiplicity(): string {
    let retMessage = "";
    this.rows.forEach((row: any) => {
      const counter = 0;
      row.recipients.forEach((recipient: any) => {
        if (recipient.distributedFinally % recipient.multiplicity > 0) {
          retMessage = "Введені кількості не відповідають кратності";
        }
      });
    });
    return retMessage;
  }

  openAttachmentsModal() {
    this.attachments.isLoading = true;
    this.attachmentsModal = true;
    this.documentsController.getAllForDistribution(this.distributionId).subscribe(data => {
      // @ts-ignore
      this.attachments.content = data;
      this.attachments.isLoading = false;
    });
  }

  downloadFile(row: DistributionDocument) {
    const url = this.documentFileApiService.getBaseUrl() + `/${row.fileId}/files`;
    this.downloadService.download(url, null, null, row.fileName);
  }

  getAttachmentsMetaData() {
    this.documentsController.getAllForDistribution(this.distributionId).subscribe(data => {
      // @ts-ignore
      this.attachments.content = data;
    });
  }

  protected readonly attachmentsTabHeader = attachmentsTabHeader2;

  sendToReworking(): void {
    this.commentStatus = "";
    this.comment = "";
    this.refuseModal = true;
  }

  archive(): void {
    this.subDistributionController.archive(this.subDistributionId).subscribe(data => {
      this.notificationService.success(data["message"]);
      this.distribution.status = "ARCHIVED";
    });
  }

  updateRemnants(): void {
    this.updateRemnantsInProgress = true;
    this.subDistributionController.updateRemnants(this.subDistributionId).subscribe(data => {
      this.updateRemnantsInProgress = false;
      this.notificationService.success(data["message"]);
      this.loadingCounter++;
      this.getSubDistribution();
    });
  }

  updateDistribution100Financed(): void {
    this.updateDistribution100FinancedInProgress = true;
    this.subDistributionController.updateRequisitions(this.subDistributionId).subscribe(data => {
      this.updateDistribution100FinancedInProgress = false;
      this.notificationService.success(data["message"]);
      this.loadingCounter++;
      this.getSubDistribution();
    });
  }

  goToSeries(): void {
    this.router.navigate([`sub/distribution/doz/series/${this.distributionId}&${this.subDistributionId}`]);
  }
}

export const tabHeaderSubDistibution = [
  { key: "1", label: "MHH" },
  { key: "2", label: "Кількість" },
  { key: "3", label: "Заклад-отримувач" },
  { key: "4", label: "Потреба закладу" },
  { key: "5", label: "Залишок закладу" },
  { key: "6", label: "Розподілено за рік" },
  { key: "7", label: "Автоматичний розподіл, враховуючи залишки" },
  { key: "8", label: "Пропорційний розподіл" },
  { key: "9", label: "Фінальний розподіл" },
  { key: "10", label: "" },
];
